import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Careers from "@/pages/Careers";
import Consulting from "@/pages/Consulting";
import RequestCare from "@/pages/RequestCare";
import Contact from "@/pages/Contact";
import Apply from "@/pages/Apply";
import AuthCallback from "@/pages/AuthCallback";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminApplicant from "@/pages/AdminApplicant";
import OnboardingLogin from "@/pages/OnboardingLogin";
import OnboardingActivate from "@/pages/OnboardingActivate";
import OnboardingPortal from "@/pages/OnboardingPortal";
import InterviewConfirm from "@/pages/InterviewConfirm";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const BARE_PREFIXES = ["/admin", "/onboarding", "/auth", "/interview"];

function Shell() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const bare = BARE_PREFIXES.some((p) => location.pathname.startsWith(p));
  return (
    <>
      <ScrollToTop />
      {!bare && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/request-care" element={<RequestCare />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/applicants/:id" element={<AdminApplicant />} />
        <Route path="/onboarding" element={<OnboardingLogin />} />
        <Route path="/onboarding/activate" element={<OnboardingActivate />} />
        <Route path="/onboarding/portal" element={<OnboardingPortal />} />
        <Route path="/interview/confirm" element={<InterviewConfirm />} />
      </Routes>
      {!bare && <Footer />}
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#1F2937",
            color: "#fff",
            border: "1px solid rgba(212,175,55,0.4)",
            borderRadius: "14px",
          },
        }}
      />
    </div>
  );
}

export default App;
